export default "__VITE_ASSET__CpWvWGJ5__"